import {Component} from '@angular/core';

@Component({
    selector: 'app-family-story',
    templateUrl: './family-story.component.html',
    styleUrls: ['./family-story.component.scss']
    })
export class FamilyStoryComponent {
}
